import { Language } from "../context/LanguageContext";

type Translations = {
  [key in Language]: {
    nav: {
      home: string;
      sources: string;
      quiz: string;
    };
    myths: {
      myth1: string;
      myth2: string;
      myth3: string;
    };
    landing: {
      welcome: string;
      title: string;
      subtitle: string;
      startButton: string;
      learnMoreButton: string;
      whatsTheFuss: string;
      titleFussCard1: string;
      descriptionFussCard1: string;
      titleFussCard2: string;
      descriptionFussCard2: string;
      titleFussCard3: string;
      descriptionFussCard3: string;
      meetTheSquad: string;
      titleTeamMember1: string;
      descriptionTeamMember1: string;
      titleTeamMember2: string;
      descriptionTeamMember2: string;
      titleTeamMember3: string;
      descriptionTeamMember3: string;
      titleCTA: string;
      descriptionCTA: string;
      ctaButton: string;
    };
    sources: {
      title: string;
      description: string;
      sources: string;

      titleMyth1: string;
      descriptionMyth1: string;
      debunkingMyth1: string;
      tldrMyth1: string;

      titleMyth2: string;
      descriptionMyth2: string;
      debunkingMyth2: string;
      tldrMyth2: string;

      titleMyth3: string;
      descriptionMyth3: string;
      debunkingMyth3: string;
      tldrMyth3: string;

      bottomText: string;
    };
    quiz: {
      yes: string;
      no: string;
      yourChoice: string;
      confirm: string;
      question1: string;
      question2: string;
      q2option1: string;
      q2option2: string;
      q2option3: string;
      q2answer: string;
      q2explanation: string;
      question3: string;
      q3explanation: string;
      question4: string;
      question5: string;
      q5option1: string;
      q5option2: string;
      q5option3: string;
      q5answer: string;
      q5explanation: string;
      question6: string;
      q6explanation: string;
      question7: string;
      question8: string;
      q8option1: string;
      q8option2: string;
      q8option3: string;
      q8answer: string;
      q8explanation: string;
      question9: string;
      q9explanation: string;
    };
    footer: {
      text: string;
      quickLinks: string;
      home: string;
      myths: string;
      sources: string;
      followUs: string;
      bottomText: string;
    };
  };
};

  // --------------------------------------------------------------------
  // 🇩🇪 DEUTSCH
  // --------------------------------------------------------------------
export const translations: Translations = {
  de: {
    nav: {
      home: "Start",
      sources: "Quellen",
      quiz: "Quiz",
    },
    myths: {
      myth1: "Mythos 1: KI DENKT WIE EIN MENSCH",
      myth2: "Mythos 2: KI WEISS ALLES ÜBER MICH",
      myth3: "Mythos 3: KI WIRD ALLE JOBS STEHLEN",
    },
    landing: {
      welcome: "Willkommen bei der Wahrheit",
      title: "KI MYTHEN AUFGEDECKT!",
      subtitle:
        "Während die Welt wegen „AGI bis Dienstag“ völlig ausflippt, liefern wir hier kalte, harte Fakten mit einer Prise Humor.",
      startButton: "Leg los!",
      learnMoreButton: "Mehr erfahren",
      whatsTheFuss: "WOZU DER AUFRUHR?",
      titleFussCard1: "Trenne Fakt von Fiktion",
      descriptionFussCard1:
        "AI ist cool, aber es ist keine Magie. Lerne, was KI wirklich kann und was nicht.",
      titleFussCard2: "Verstehe die Auswirkungen",
      descriptionFussCard2:
        "Kein Fachjargon. Kein Blödsinn. Nur echte Erklärungen dazu, was KI kann und was nicht.",
      titleFussCard3: "Hab Spaß dabei!",
      descriptionFussCard3:
        "Der Hype um KI ist lächerlich – da muss man doch darüber lachen.",
      meetTheSquad: "Treffe das Team",
      titleTeamMember1: "Platy",
      descriptionTeamMember1: "Der Mythos Entlarver",
      titleTeamMember2: "Bratwurst",
      descriptionTeamMember2: "Der KI Wahrheitsfinder",
      titleTeamMember3: "Hamster",
      descriptionTeamMember3: "Faktenjäger",
      titleCTA: "Bereit, ein paar Mythen zu zerstreuen?",
      descriptionCTA:
        "Werden Sie Teil unserer Gemeinschaft von Wahrheitssuchenden und Mythos-Entlarvern.",
      ctaButton: "Folge uns auf Instagram",
    },

    sources: {
      title: "Quellenangaben",
      description:
        "Hier findest du eine Liste mit allen Mythen, die wir entlarvt haben, zusammen mit ihren jeweiligen Quellen:",
      sources: "Quellen:",

      titleMyth1: "Mythos #1 - KI denkt wie ein Mensch",
      descriptionMyth1:
        "Der Mythos, dass künstliche Intelligenz wie ein Mensch denkt, stammt aus Missverständnissen über KI und aus Science-Fiction-Darstellungen in Filmen wie 'Her' oder 'Ex Machina'. Menschen neigen außerdem dazu, nicht-menschlichen Dingen menschliche Eigenschaften zuzuschreiben (Anthropomorphismus). Sprachmodelle wirken oft so, als würden sie verstehen – obwohl sie lediglich statistische Muster berechnen.",
      debunkingMyth1:
        "KI wirkt manchmal „menschlich“, aber sie denkt nicht, fühlt nicht und versteht nicht. Große Sprachmodelle treffen Vorhersagen über das wahrscheinlichste nächste Wort – nicht aufgrund eigener Ideen oder Absichten. Forschende bezeichnen sie daher als 'stochastic parrots'. Weder Bewusstsein noch Emotionen oder echte mentale Modelle sind vorhanden.",
      tldrMyth1:
        "KI simuliert Intelligenz durch Mustererkennung - aber sie denkt nicht wie ein Mensch.",
      
      titleMyth2: "Mythos #2 - KI weiß alles über mich",
      descriptionMyth2:
        "Der Mythos, dass KI alles über eine Person weiß, entsteht häufig durch die falsche Vorstellung, dass Systeme wie ChatGPT Zugang zu privaten Datenbanken, dem Smartphone oder dem gesamten Internet haben. Tatsächlich können KI-Modelle keine persönlichen Informationen nachschlagen oder identifizieren. Sie arbeiten ausschließlich mit Trainingsdaten und dem, was Nutzer selbst eingeben.",
      debunkingMyth2:
        "Moderne KI weiß nicht, wer du bist, wo du wohnst oder welche Daten über dich existieren. Sprachmodelle haben keinen Zugriff auf private Datenbanken, Social-Media-Konten, Browserverläufe oder GPS-Daten. Sie können keine Personen identifizieren und raten nicht deine Identität. Datenschutzgesetze wie die DSGVO verbieten zudem die Verarbeitung personenbezogener Daten ohne Zustimmung.",
      tldrMyth2:
        "KI weiß nichts über dich - außer dem, was du selbst eingibst. Sie hat keinen Zugriff auf persönliche Daten oder das Internet.",

      titleMyth3: "Mythos #3 - KI wird alle Jobs stehlen",
      descriptionMyth3:
        "Der Mythos, dass KI eines Tages alle Jobs übernehmen wird, speist sich aus der Angst vor Automatisierung und spektakulären Medienberichten. Historisch haben technologische Umbrüche – von der Industrialisierung bis zur Computerisierung – zwar einzelne Tätigkeiten ersetzt, gleichzeitig aber neue Berufsfelder geschaffen. KI automatisiert vor allem standardisierte, wiederkehrende Aufgaben, nicht jedoch komplexe Tätigkeiten, die Kreativität, Empathie oder soziale Intelligenz erfordern.",
      debunkingMyth3:
        "KI ersetzt keine ganzen Berufe, sondern bestimmte Aufgaben innerhalb eines Jobs. Sie unterstützt Menschen bei Routinetätigkeiten, Datenanalyse oder Mustererkennung und schafft damit Raum für Tätigkeiten mit höherem Mehrwert. Studien zeigen, dass viele Jobs sich verändern werden, aber nur ein kleiner Teil vollständig verschwindet. Gleichzeitig entstehen neue Rollen wie Prompt-Engineers, Data Stewards oder KI-Ethik-Expert:innen. Die eigentliche Herausforderung liegt in Weiterbildung, Umschulung und fairer Gestaltung des Wandels – nicht in einem totalen Jobverlust.",
      tldrMyth3:
        "KI wird Arbeit verändern, aber nicht alle Jobs stehlen. Sie automatisiert Aufgaben und schafft gleichzeitig neue Tätigkeiten und Berufsbilder.",

      bottomText:
        "Für weitere Informationen und vertiefende Literatur empfehlen wir die oben genannten Links.",
    },

    quiz: {
      yes: "Ja",
      no: "Nein",
      confirm: "Bestätigen",
      yourChoice: "Deine Wahl:",
      question1: "Denkt eine KI wie ein Mensch?",
      question2: "Warum denkst du das?",
      q2option1:
        "Weil KI kein Gehirn hat, sondern nur künstliche Neuronen, die rechnen.",
      q2option2:
        "Weil sie nie schläft, also keine Träume oder verrückte Ideen hat.",
      q2option3:
        "Weil sie keinen Kaffee trinken kann, um ihr Denken anzuregen.",
      q2answer:
        "Weil KI kein Gehirn hat, sondern nur künstliche Neuronen, die rechnen.",
      q2explanation:
        "KI hat kein Bewusstsein und versteht nicht im menschlichen Sinne. Sie berechnet Wahrscheinlichkeiten.",
      question3: "Wie viel Prozent der Menschen glauben an diesen Mythos?(0-100)",
      q3explanation:
        "Etwa 30% der Menschen glauben, dass KI eine Form von Bewusstsein hat.",
      question4: "Weiß eine KI alles über dich?",
      question5: "Warum denkst du das?",
      q5option1:
        "Wahrscheinlich, weil KI wie ein mysteriöses Super-Gehirn aus einer Sci-Fi-Serie aussieht.",
      q5option2: "Weil Menschen denken, dass KI sie ausspionieren kann.",
      q5option3:
        "Das ist nur ein Mythos. KI kann dich nicht ausspionieren oder verfolgen - sie verwendet nur den Text, den du eingibst.",
      q5answer:
        "Das ist nur ein Mythos. KI kann dich nicht ausspionieren oder verfolgen - sie verwendet nur den Text, den du eingibst.",
      q5explanation:
        "KI hat keinen Zugriff auf private Datenbanken oder persönliche Informationen",
      question6: "Wie viel Prozent der Menschen glauben an diesen Mythos?(0-100)",
      q6explanation:
        "Eine Cisco-Studie zeigt: 30% geben persönliche Infos ein - aus Angst, nicht weil KI alles weiß.",
      question7: "Wird KI alle Jobs stehlen?",
      question8: "Warum denkst du das?",
      q8option1:
        "Weil mein Kollege schon Angst hat, dass KI seinen Platz im Monatsbericht einnimmt.",
      q8option2:
        "Weil mein virtueller Assistent meine E-Mails besser verwaltet als ich.",
      q8option3:
        "Weil KI repetitive Aufgaben automatisieren kann, aber keine Kreativität besitzt.",
      q8answer:
        "Weil KI bestimmte repetitive oder standardisierte Aufgaben automatisieren kann, aber keine unerwarteten Ereignisse bewältigen kann.",
      q8explanation:
        "KI ersetzt Aufgaben, aber nicht ganze Berufe mit menschlichen Qualitäten.",
      question9: "Wie viel Prozent der Menschen glauben an diesen Mythos?(0-100)",
      q9explanation:
        "Etwa 49% der Deutschen fürchten, dass KI Arbeitsplätze gefährdet.",
    },

    footer: {
      text: "Mit Fakten gegen den Hype, ein Mythos nach dem anderen.",
      quickLinks: "Schnellzugriff",
      home: "Start",
      myths: "Mythen",
      sources: "Quellen",
      followUs: "Folge uns",
      bottomText: `${new Date().getFullYear()} AI Myth Busters. Hier sind alle Mythen willkommen.`,
    },
  },

  // --------------------------------------------------------------------
  // 🇺🇸 ENGLISH
  // --------------------------------------------------------------------
  en: {
    nav: {
      home: "Home",
      sources: "Sources",
      quiz: "Quiz",
    },
    myths: {
      myth1: "Myth 1 : AI THINKS LIKE A HUMAN",
      myth2: "Myth 2 : AI KNOWS EVERYTHING ABOUT ME",
      myth3: "Myth 3 : AI WILL STEAL ALL JOBS",
    },
    landing: {
      welcome: "Welcome to the Truth",
      title: "BUSTING AI MYTHS!",
      subtitle:
        "While the world is losing their minds over „AGI by Tuesday“, we're here serving cold, hard facts with a side of humor.",
      startButton: "Start Exploring",
      learnMoreButton: "Learn More",
      whatsTheFuss: "WHAT'S THE FUSS?",
      titleFussCard1: "Separate Fact from Fiction",
      descriptionFussCard1:
        "AI is cool, but it's not magic. Learn what AI can really do and what it can't.",
      titleFussCard2: "Understand the Impact",
      descriptionFussCard2:
        "No jargon. No BS. Just real explanations about what AI can and cannot do.",
      titleFussCard3: "Have Fun!",
      descriptionFussCard3:
        "The hype around AI is ridiculous - you have to laugh about it.",
      meetTheSquad: "Meet the Squad",
      titleTeamMember1: "Platy Meier",
      descriptionTeamMember1: "Myth Buster Extraordinaire",
      titleTeamMember2: "Bratwurst",
      descriptionTeamMember2: "AI Truth Seeker",
      titleTeamMember3: "Hamster",
      descriptionTeamMember3: "Fact Hunter",
      titleCTA: "Ready to Bust Some Myths?",
      descriptionCTA: "Join our community of truth seekers and myth busters.",
      ctaButton: "Follow us on Instagram",
    },

    sources: {
      title: "Sources",
      description:
        "Here you will find a list with all myths we have debunked along with their respective sources:",
      sources: "Sources:",

      titleMyth1: "Myth #1 - AI thinks like a human",
      descriptionMyth1:
        "The myth that AI thinks like a human comes from misunderstandings and sci-fi portrayals of conscious machines. Humans often anthropomorphize technology, and large language models can give an illusion of understanding, even though they work purely statistically.",
      debunkingMyth1:
        "AI does not think, feel, or understand. Language models predict text based on statistical patterns rather than ideas or intentions. Researchers describe AI as 'stochastic parrots' because they lack consciousness, emotions, and mental models.",
      tldrMyth1:
        "AI imitates intelligence using patterns, but it does not think like a human.",

      titleMyth2: "Myth #2 - AI knows everything about me",
      descriptionMyth2:
        "The myth that AI knows everything about a person comes from the mistaken belief that systems like ChatGPT have access to private databases, smartphones, or the entire internet. In reality, AI cannot retrieve personal data or identify individuals and only works with training data and user-provided input.",
      debunkingMyth2:
        "Modern AI does not know who you are, where you live, or what data exists about you. Language models have no access to private databases, social media accounts, browsing history, or GPS information. AI cannot identify individuals and does not 'guess' your identity. Privacy laws such as GDPR prohibit processing personal data without consent.",
      tldrMyth2:
        "AI knows nothing about you unless you tell it. It has no access to private data or the internet.",

      titleMyth3: "Myth #3 - AI will steal all jobs",
      descriptionMyth3:
        "The myth that AI will eventually steal all jobs is fueled by fears of automation and eye-catching headlines. Historically, major technological shifts – from industrialization to computerization – have automated certain tasks while creating entirely new professions. AI is particularly strong at automating repetitive, standardized activities, not at replacing complex work that requires creativity, empathy, or social intelligence.",
      debunkingMyth3:
        "AI does not replace entire professions, but specific tasks within them. It supports humans by handling routine work, data processing, and pattern recognition, freeing time for higher-value activities. Research suggests that many jobs will change, but only a small fraction will disappear entirely. At the same time, new roles are emerging, such as prompt engineers, data stewards, and AI ethics specialists. The real challenge lies in reskilling, upskilling, and fair transition – not in a total loss of work.",
      tldrMyth3:
        "AI will change how we work, but it won’t steal all jobs. It automates tasks and creates new roles and opportunities.",

      bottomText:
        "For more information and further reading, we recommend the links listed above.",
    },

    quiz: {
      yes: "Yes",
      no: "No",
      confirm: "Confirm",
      yourChoice: "Your choice:",
      question1: "Does AI think like a human?",
      question2: "Why do you think so?",
      q2option1:
        "Because AI doesn't have a brain, only artificial neurons that calculate.",
      q2option2:
        "Because it never sleeps, so it has no dreams or weird ideas.",
      q2option3: "Because it can't drink coffee to boost its thinking.",
      q2answer:
        "Because AI doesn't have a brain, only artificial neurons that calculate.",
      q2explanation:
        "AI has no consciousness, intentions, or emotions. It simply computes probabilities.",
      question3: "What percentage of people believe this myth? (0-100)",
      q3explanation:
        "About 30% believe that AI has some form of consciousness.",
      question4: "Does AI know everything about you?",
      question5: "Why do you think so?",
      q5option1:
        "Probably because AI seems like a mysterious super-brain from a sci-fi series.",
      q5option2: "Because people think AI can spy on them.",
      q5option3:
        "That's just a myth. AI can't spy on you — it only uses the text you type.",
      q5answer:
        "That's just a myth. AI can't spy on you — it only uses the text you type.",
      q5explanation:
        "AI does not have access to personal databases or private information.",
      question6: "What percentage of people believe this myth? (0-100)",
      q6explanation:
        "A 2024 Cisco study highlights privacy fears, not actual AI knowledge.",
      question7: "Will AI steal all jobs?",
      question8: "Why do you think so?",
      q8option1:
        "Because my colleague fears that AI will take over his monthly report.",
      q8option2:
        "Because my virtual assistant manages emails better than I do.",
      q8option3:
        "Because AI automates repetitive tasks but can't be creative like humans.",
      q8answer:
        "Because AI automates repetitive tasks but cannot handle unexpected events creatively.",
      q8explanation:
        "AI replaces tasks, not full jobs requiring complex human abilities.",
      question9: "What percentage of people believe this myth? (0-100)",
      q9explanation:
        "Around 49% of Germans fear AI could threaten jobs.",
    },

    footer: {
      text: "Fighting hype with facts, one myth at a time.",
      quickLinks: "Quick Links",
      home: "Home",
      myths: "Myths",
      sources: "Sources",
      followUs: "Follow Us",
      bottomText: `${new Date().getFullYear()} AI Myth Busters. All myths welcome here.`,
    },
  },
};
